<div class="workSpace">
  <div class="headersTab">
    <!-- Nombre y Subtitulos -->
    <div class="w3-caja-menu padreizquierda w3-veinte">
      <div class="w3-row hijoizquierda">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ "menu." + dataService.moduleSelect | translate }} </b> </span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ "menu." + dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
    <!-- Filtros -->
    <div class="w3-rest">
      <div class="w3-noventa2 w3-row">
        <div class="w3-third padreizquierda" [ngClass]="{'w3-disabled': monthSelect}">
          <app-filters
            [name]="'filtros.anio' | translate"
            [array]="yearsAvailable"
            [typeFilter]="Filters.YEAR"
            (eventClick)="yearChange($event)"
            [click]="false"
          >
          </app-filters>
        </div>
        <div class="w3-third padreizquierda"  [ngClass]="{'w3-disabled': monthSelect}">
          <app-filters
            [name]="'filtros.anio' | translate"
            [array]="periodicidad"
            [typeFilter]="Filters.PERSPECTIVES"
            (eventClick)="periodicityChange($event)"
            [click]="false"
          >
          </app-filters>
        </div>
        <div class="w3-third padreizquierda"  [ngClass]="{'w3-disabled': monthSelect}">
          <app-filters
            [name]="'filtros.sucursales' | translate"
            [array]="sucursales"
            [typeFilter]="Filters.SUCURSALES"
            [click]="false"
            [consolidado]="consolidado"
            (eventClick)="sucursalChange($event)"
          >
            <!-- (eventClick)="periodicityChange($event)" -->
          </app-filters>
        </div>
      </div>
      <div class="w3-rest padreizquierda w3-right" style="height: 7vh; padding-top: 2vh; z-index: 100;">
        <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" (click)="resetFilters()"
          matTooltip="{{'tooltips.borrar-filtros'|translate}}">
          <img src="./../../../../assets/img/eraser.png">
        </div>
        <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menu">
          more_vert
        </mat-icon>
        <mat-menu #menu="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarPDF()">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar'|translate}}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  <div class="workSpaceTab">
    <!-- Graficas -->
    <div class="w3-row">
      <div class="w3-white" style="height: 42vh; width: 98vw; margin-left: auto; margin-right: auto;">
        @if (!reset1) {
          <app-graficas
            [data]="data1"
            [type]="types.COMBO"
            [labels]="labels1"
            [axisY]="axisY1"
            [tituloZona]="tituloZona1"
            [graphicsAvaibable]="graphics1"
            [zona]="zona1"
            [subTituloZona]="subtitles1"
            [perspectivesAvaibable]="perspectives"
            [exportSuc]="true"
            (exportSucursales)="exportarSucursales()"
            (eventClick)="clickGraphicPrincipal($event)"
          >
          </app-graficas>
        }
      </div>
    </div>
    <div class="w3-row" style="margin-top: 2vh;">
      <div class="w3-white zonaInferior">
        <div style="width: 98%; height: 98%; margin-left: auto; margin-right: auto;">
          @if (!reset2) {
            <app-graficas
              [data]="data2"
              [type]="types.DONUT"
              [labels]="labels2"
              [axisY]="axisY2"
              [tituloZona]="tituloZona2"
              [graphicsAvaibable]="graphics2"
              [zona]="zona2"
              (eventClick)="clickGraphicFilter($event)"
              [subTituloZona]="subtitles2"
            >
            </app-graficas>
          }
        </div>
      </div>
      <div class="w3-white zonaInferior">
        <div style="width: 98%; height: 95%; margin-left: auto; margin-right: auto;">
          @if (!reset3) {
            <app-graficas
              [data]="data3"
              [type]="types.COMBO"
              [labels]="labels3"
              [axisY]="axisY3"
              [tituloZona]="tituloZona3"
              [graphicsAvaibable]="graphics3"
              [zona]="zona3"
              [subTituloZona]="subtitles2"
            >
            </app-graficas>
          }
        </div>
      </div>
    </div>
  </div>
</div>
